/**
 * Mixed Inventory Booking Store - Main Export
 *
 * @module mixedInventoryStore
 * @description Zustand store for managing multi-room booking flow with session persistence
 */

export { useMixedInventoryStore } from './mixedInventoryStore';
export { initializeMixedInventoryStore } from './initializeMixedInventoryStore';

export type { MixedInventoryStore, MixedInventoryBookingState, MixedInventoryBookingActions } from './interface';

export type {
  SearchCriteriaState,
  RoomSearchCriteria,
  RoomProgressionState,
  CartState,
  UIState,
  NavigationState,
  ErrorState,
  SessionMetadata,
  SelectedRoom,
  MixedInventoryScenario,
  NavigationIntent,
} from './types';

export { initialMixedInventoryState } from './defaultState';
